import { render, staticRenderFns } from "./FrmNewAbsence.vue?vue&type=template&id=57dd55d8"
import script from "./FrmNewAbsence.vue?vue&type=script&lang=js"
export * from "./FrmNewAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports